import React from 'react';

const EmailTemplatesPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default EmailTemplatesPage;
